import React from 'react';
import { handleEnterKeyToClick } from '../Common/accessibilityHelpers';
import { Modal } from 'react-bootstrap';
import styles from './Hssr.module.scss';
import { Language } from './language';

interface Props {
    show: boolean;
    onHideModal: () => void;
    language: Language;
}

export const HssrRequestedAppModal = ({ show, onHideModal, language }: Props) => {
    return (
        <Modal centered show={show} onHide={onHideModal}>
            <div className={styles['success-alert']}>
                <div className={styles['success-modal-container']}>
                    <div className="text-center">
                        <p>
                            {language.thankYou}
                        </p>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            className={styles['modal-btn']}
                            onClick={onHideModal}
                            onKeyUp={handleEnterKeyToClick}
                            tabIndex={0}
                        >
                             {language.thankYouOK}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
